import { memo, useState } from "react";
import { Grid, Button, CircularProgress, Alert } from "@mui/material";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import ChangeStatusModal from "../modals/Deliveries/ChangeStatusModal";


const MassiveChangeStatusModal = ({
  selectedDeliveries,
  loading,
  error,
  success,
  massiveChangeStatus,
  refetchDeliveries,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleChangeStatus = async (status, subStatus) => {
    try {
      if (
        window.confirm(
          "¿Estas seguro que quieres actualizar todos los estados?\nEsta acción modificara todos los items asociados",
        )
      ) {
        const responseMessage = await massiveChangeStatus({
          ids: selectedDeliveries,
          status,
          subStatus,
        });
        handleCloseModal();
        alert(success || responseMessage);
      }
    } catch (error) {
      console.error(
        `Error al cambiar estados, ahora se cargara error via la variable error: ${error.response?.data?.message}`,
      );
      alert(
        `Error al cambiar estados de envio: ${error?.response?.data?.message}`,
      );
      handleCloseModal();
    } finally {
      window.location.reload();
    }
  };

  const isButtonDisabled = loading || selectedDeliveries.length === 0;

  return (
    <>
      <Grid item xs={12} md={2} xl={2}>
        <Button
          variant="outlined"
          onClick={handleOpenModal}
          disabled={isButtonDisabled}
          startIcon={
            loading ? (
              <CircularProgress size={20} />
            ) : (
              <GroupAddIcon fontSize="small" />
            )
          }
        >
          {loading ? "Procesando..." : "Modificar envíos"}
        </Button>
        {error && (
          <Alert severity="error" sx={{ mt: 1, fontSize: "0.8rem" }}>
            {error}
          </Alert>
        )}
      </Grid>

      <ChangeStatusModal
        open={isModalOpen}
        onClose={handleCloseModal}
        onConfirm={handleChangeStatus}
        loading={loading}
      />
    </>
  );
};

export default memo(MassiveChangeStatusModal);
